import { Variants } from "../configs/configs.types";

const variant = process.env.REACT_APP_VARIANT ?? Variants.v0;

/**
 * Получает значение из конфигурации с учетом вариантов
 * @param baseValue - базовое значение
 * @param variants - варианты для разных версий
 * @returns значение для текущей версии
 */
export function getConfigValue<T>(
  baseValue: T,
  variants?: { [key: string]: T }
): T {
  if (!variants || variant === Variants.v0 || variant === Variants.v5) {
    return baseValue;
  }

  return variants[variant] || baseValue;
}

/**
 * Получает заголовок с учетом вариантов
 */
export function getTitleWithVariant(
  baseTitle: string,
  titleVariants?: { [key: string]: string }
): string {
  return getConfigValue(baseTitle, titleVariants);
}

/**
 * Получает описание с учетом вариантов
 */
export function getDescriptionWithVariant(
  baseDescription: string,
  descriptionVariants?: { [key: string]: string }
): string {
  return getConfigValue(baseDescription, descriptionVariants);
}

/**
 * Получает список карточек с учетом вариантов
 */
export function getCardListWithVariant<T>(
  baseCardList: T[],
  cardListVariants?: { [key: string]: T[] }
): T[] {
  return getConfigValue(baseCardList, cardListVariants);
}

/**
 * Получает описание (массив строк) с учетом вариантов
 */
export function getDescriptionArrayWithVariant(
  baseDescription: string[],
  descriptionVariants?: { [key: string]: string[] }
): string[] {
  return getConfigValue(baseDescription, descriptionVariants);
}
